import baseUrl from './baseUrl';

const URL_DELETAR_USUARIO = `${baseUrl}/user`;

const deletarUsuario = async id => {
  try {
    const response = await fetch(`${URL_DELETAR_USUARIO}/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }
  } catch (error) {
    console.log(error);
  }
};

export default deletarUsuario;
